import React from "react";
import "./MultiUpload.css";
import { CircularProgress } from "@material-ui/core";
import FileUpload from "./FileUpload";
import { isBlank } from "Util/Utilities";
import { PortalDialog } from "../CommonComponents";
import { Close } from '@mui/icons-material';
import { IconButton } from "@material-ui/core";

export type UploadData = {
  // s3 url to pass to upsert api
  s3Url: string;

  // blob url for image or data url for video
  displayUrl: string;
};

type MultiUploadProps = {
  type:
  | "doctor_memo"
  | "home_env_photo"
  | "mt_video"
  | "cr_avatar"
  | "payment_proof"
  | "medication_photos";
  className?: string;
  coId?: string;
  onUploadSuccess?: (files: UploadData[]) => void;
};

type MultiUploadState = {
  _isDragging?: boolean;
  _isUploading?: boolean;
};

export default class MultiUpload extends React.Component<
  MultiUploadProps,
  MultiUploadState
> {
  files: UploadData[] = [];
  _isMounted = false;

  constructor(props: MultiUploadProps) {
    super(props);
    this.state = {};
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _onUploadSuccess = (_fileName: string, s3Url: string, fileUrl: string) => {
    const self = this;
    //const isVideo = self.props.type === "mt_video";
    if (!self._isMounted) return;

    self.files.push({
      s3Url: s3Url,
      displayUrl: fileUrl,
    });
  };

  _startUpload = () => {
    this.files = [];
    this.setState({ _isUploading: true });
  };
  _endUpload = () => {
    const self = this;
    if (!self._isMounted) return;

    const files = self.files;
    self.setState({ _isUploading: false });
    self.files = [];

    const onUploadSuccess = self.props.onUploadSuccess;
    !isBlank(files) && onUploadSuccess && onUploadSuccess(files);
  };
  _onDragChange = (isDragging: boolean) => {
    this.setState({ _isDragging: isDragging });
  };

  render() {
    const self = this;
    const state = self.state;
    const props = self.props;
    const type = props.type;
    const isVideo = type === "mt_video";
    const isUploading = state._isUploading;

    return (
      <FileUpload
        className={"mu-main " + (props.className || "")}
        type={type}
        coId={props.coId}
        acceptType={isVideo ? "video/*" : "image/*"}
        multiSelect
        onDragChange={self._onDragChange}
        onStart={self._startUpload}
        onError={self._endUpload}
        onEnd={self._endUpload}
        onSuccess={self._onUploadSuccess}
      >
        <div className="mu-bg" />
        {state._isDragging && <div className="mu-bg mu-overlay" />}

        <img src="/self-serve/ic_upload@3x.png" className="mu-ico" alt="" />

        <div className="mu-txt">
          Drop or browse {isVideo ? "videos" : "images"}
        </div>

        {isUploading && (
          <div className="mu-bg mu-overlay">
            <CircularProgress color="primary" />
          </div>
        )}
      </FileUpload>
    );
  }
}

export type MultiUploadDialogProps = {
  coId: string;
  type:
  | "doctor_memo"
  | "home_env_photo"
  | "mt_video"
  | "cr_avatar"
  | "payment_proof"
  | "medication_photos";
  onClose: () => void;
  onUploadSuccess?: (files: UploadData[]) => void;
};

export const MultiUploadDialog = ({
  onClose,
  coId,
  type,
  onUploadSuccess,
}: MultiUploadDialogProps) => {
  return (
    <PortalDialog
      className="ha-dialog ha-dialog-appear iu-dlg"
      // disableScroll
      result={onClose}
    >
      <div className="iu-dlg-cont">
        <IconButton
          className="iu-dlg-close"
          onClick={onClose}
          aria-label="close"
        >
          <Close />
        </IconButton>
      </div>

      <MultiUpload type={type} coId={coId} onUploadSuccess={onUploadSuccess} />
    </PortalDialog>
  );
};
